export function createOfferReducer(
    state = { createofferData: [] },
    { type, payload }
  ) {
    switch (type) {
      case "CREATE_OFFER_AUCTION":
        return { ...state, createofferData: payload };
      default:
        return state;
    }
  }